import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import PropTypes from "prop-types"
import { can, VIEW_PROJECTS } from "@src/helpers/authorization"
import { updateUsersAccess } from "@api/project/access"
import Modal from "../../../../team_access/modal"

const Members = ({ project, onClose, updateUsersAccess, ...props }) => {
  return (
    <Modal
      onClose={onClose}
      attachedUserIDs={project.user_ids}
      updateUsersAccess={(userIDs, callback) => updateUsersAccess(project._id, userIDs, callback)}
      {...props}/>
  )
}

Members.propTypes = {
  project: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  updateUsersAccess: PropTypes.func.isRequired,
  roleUsers: PropTypes.array,
}

const mapStateToProps = state => ({
  roleUsers: state.user.auth.organization_id
    ? state.settings.organizations.members.items.filter(user => can(user, [VIEW_PROJECTS]))
    : [],
  parentUsers: state.projects.breadcrumb.reduce((acc, folder) => {
    return acc.concat(folder.users || [])
  }, [])
})

const mapDispatchToProps = dispatch => ({
  updateUsersAccess: bindActionCreators(updateUsersAccess, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(Members)
